import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import { Plan } from '../hooks/HighLevelContext/types';

interface PlanContextType {
  selectedPlan: Plan | null;
  setSelectedPlan: (plan: Plan | null) => void;
  billingAmount: number;
  setBillingAmount: (amount: number) => void;
  planType: string;
  setPlanType: (type: string) => void;
  billingCycle: string;
  setBillingCycle: (cycle: string) => void;
  // HighLevel integration
  highlevelProductId: string | null;
  setHighlevelProductId: (id: string | null) => void;
  highlevelPriceId: string | null;
  setHighlevelPriceId: (id: string | null) => void;
  // Payment data
  paymentData: any;
  setPaymentData: (data: any) => void;
  clearPlanData: () => void;
}

const PlanContext = createContext<PlanContextType | undefined>(undefined);

interface PlanProviderProps {
  children: ReactNode;
}

export const PlanProvider: React.FC<PlanProviderProps> = ({ children }) => {
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
  const [billingAmount, setBillingAmount] = useState<number>(0);
  const [planType, setPlanType] = useState<string>('');
  const [billingCycle, setBillingCycle] = useState<string>('Monthly');
  const [highlevelProductId, setHighlevelProductId] = useState<string | null>(null);
  const [highlevelPriceId, setHighlevelPriceId] = useState<string | null>(null);
  const [paymentData, setPaymentData] = useState<any>(null);

  const clearPlanData = useCallback(() => {
    setSelectedPlan(null);
    setBillingAmount(0);
    setPlanType('');
    setBillingCycle('Monthly');
    setHighlevelProductId(null);
    setHighlevelPriceId(null);
    setPaymentData(null);
  }, []);

  const value: PlanContextType = {
    selectedPlan,
    setSelectedPlan,
    billingAmount,
    setBillingAmount,
    planType,
    setPlanType,
    billingCycle,
    setBillingCycle,
    highlevelProductId,
    setHighlevelProductId,
    highlevelPriceId,
    setHighlevelPriceId,
    paymentData,
    setPaymentData,
    clearPlanData,
  };

  return (
    <PlanContext.Provider value={value}>
      {children}
    </PlanContext.Provider>
  );
};

export const usePlanContext = (): PlanContextType => {
  const context = useContext(PlanContext);
  if (context === undefined) {
    throw new Error('usePlanContext must be used within a PlanProvider');
  }
  return context;
};
























